import { CountryEnum as r } from "./country-enum.mjs";
import n from "../../_virtual/index.mjs";
import { LocaleEnum as o } from "../../libs/types/dist/index11.mjs";
import { getLanguageCodeByLocale as s } from "../locales/language-utils.mjs";
const c = (t, a) => {
  try {
    return new Intl.DisplayNames([t], { type: "region" }).of(a);
  } catch {
    return;
  }
}, i = "Canary Islands", m = (t, a) => {
  const e = s(a);
  switch (t) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case r.Taiwan:
      return n.getName(t, e, { select: "alias" }) ?? t;
    case r.CanaryIslands:
      return c(e, t) ?? i;
    default:
      return n.getName(t, e, { select: "official" }) ?? t;
  }
}, N = (t = o.ENGLISH) => Object.values(r).map((a) => ({
  id: a,
  caption: m(a, t)
}));
export {
  N as getCountryData,
  m as getCountryName
};
